<script setup lang="ts">
const props = defineProps<{
  name?: string;
  image: string;
  emitterName: string;
  showImage?: boolean;
}>();

const text = `${props.emitterName}${props.name ? ` ${props.name}` : ''}`;
</script>

<template>
  <div class="text-no-wrap d-flex align-center">
    <v-avatar v-if="showImage" class="mr-2" size="22">
      <v-img :src="image" />
    </v-avatar>
    <span>
      {{ text }}
    </span>
  </div>
</template>
